"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileUploadButton;
var _styles = require("@mui/material/styles");
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VisuallyHiddenInput = (0, _styles.styled)('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});
function FileUploadButton({
  onFileUpload,
  buttonText,
  icon,
  tooltip = '',
  buttonStyle
}) {
  if (!icon && !buttonText) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: tooltip || buttonText,
    children: icon ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_IconButton.default, {
      color: "inherit",
      component: "label",
      sx: buttonStyle,
      children: [icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(VisuallyHiddenInput, {
        type: "file",
        onChange: onFileUpload
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
      variant: "contained",
      component: "label",
      sx: buttonStyle,
      children: [buttonText, /*#__PURE__*/(0, _jsxRuntime.jsx)(VisuallyHiddenInput, {
        type: "file",
        onChange: onFileUpload
      })]
    })
  });
}